import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  DOCUMENTO_APORTADO,
  DOCUMENTO_INCIDENCIA,
  DOCUMENTO_NO_APLICA,
  DOCUMENTO_NO_APORTADO,
} from '@app/@core/constants/requests.constants';
import { UserAttributionsEnum } from '@app/@core/constants/user-credentials.constants';
import { AuthenticationService } from '@app/login';
import { DocumentIdNumRequestDTO, Operation } from '@app/requests/model/requests-model';
import { UpdateDocumentationStore } from '@app/requests/update-documentation/update-documentation.store';

@Component({
  selector: 'scf-request-documentation',
  templateUrl: './request-documentation.component.html',
  styleUrls: ['./request-documentation.component.scss'],
})
export class RequestDocumentationComponent implements OnInit {
  @Input() documentation: any[] = [];
  @Input() operation: Operation;
  @Input() docId: string;
  displayedColumns: string[] = ['revision', 'comprobado'];

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private updateDocumentationStore: UpdateDocumentationStore
  ) {}

  ngOnInit(): void {
    console.log(this.operation);
    console.log(this.documentation);
    console.log('ID: ', this.docId);
  }

  onClickAttach(element: Operation): void {
    let document = this.updateDocumentationStore.getDocumentIdNumRequestHistoryByNumRequest(element.numOperation);
    if (!document) {
      const documentIdNumRequestDTO: DocumentIdNumRequestDTO = {
        documentId: element.legalIdentity,
        numOperation: element.numOperation,
        commercialProduct: element.commercialProduct,
      };
      this.updateDocumentationStore.addDocumentIdNumRequestHistory(documentIdNumRequestDTO);
    }

    this.router.navigate(['/requests/update-documentation/', element.numOperation, { goBack: true }], {
      replaceUrl: false,
      state: {
        commercialProduct: element.commercialProduct,
      },
    });
  }

  hasAttachAttribution(): boolean {
    return (
      this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ATTACH_DOCUMENTATION) &&
      !this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ALTA_BP)
    );
  }

  getDocumentStatus(status: string) {
    switch (status) {
      case DOCUMENTO_APORTADO:
        return 'request.documentation.status.a';
      case DOCUMENTO_INCIDENCIA:
        return 'request.documentation.status.i';
      case DOCUMENTO_NO_APORTADO:
        return 'request.documentation.status.f';
      case DOCUMENTO_NO_APLICA:
        return 'request.documentation.status.v';
      default:
        return '';
    }
  }
}
